import { css } from '@emotion/react';

import image from 'src/assets/jpg/succes-failure-hero.jpg';
import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    }),

    imageContainer: css({
        marginBottom: '50px',
        height: '190px',
        flexShrink: '0',
        background: `url(${image}) lightgray no-repeat center/cover`,
        backgroundPosition: '45% 32%',
        backgroundSize: '150%',

        [theme.breakpoints.up('lg')]: {
            backgroundSize: '100%',
        },
    }),

    wrapper: css({
        padding: '0 20px',
        alignSelf: 'center',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '30px',
        marginBottom: '85px',
        [theme.breakpoints.up('lg')]: {
            width: '494px',
            gap: '40px',
        },
    }),

    cta: css({
        display: 'flex',
        height: '45px',
        padding: '16px 16px 12px 16px',
        borderRadius: '100px',
        width: '100%',
        textTransform: isHosTheme ? 'none' : 'uppercase',
        margin: '28px 0 12px 0',
    }),

    paymentWrapper: {
        padding: '30px 20px',
        maxWidth: '420px',
        textAlign: 'center',
        boxShadow: '2px 4px 30px rgba(0, 0, 0, 0.08)',
    },

    paymentAmount: {
        margin: '8px 0',
        fontSize: '38px',
    },

    iconsPanel: {
        marginTop: '24px',
        padding: '16px',
    },

    iconsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridTemplateRows: 'auto auto',
        justifyItems: 'center',
        rowGap: '24px',

        '& svg': {
            maxWidth: '100%',
            gridColumn: 'span 4',
        },

        '& svg:nth-of-type(n+4)': {
            gridColumn: 'span 3',
        },
    },

    divider: {
        margin: '20px 0px',
    },
};
